// Keep a hover-opened menu open on activation; Sleek otherwise toggles it closed
// immediately after focus/mouseenter. Touch and click-trigger menus retain Sleek behavior.
if (!customElements.get('fe-navigation-events')) {
  customElements.define('fe-navigation-events', class extends HTMLElement {
    connectedCallback() {
      this.events?.abort();
      this.events = new AbortController();
      const section = this.closest('.shopify-section');
      document.addEventListener('click', event => {
        const summary = event.target.closest?.('summary[data-fe-nav-trigger]');
        if (!summary || summary.closest('.shopify-section') !== section) return;
        const menu = summary.parentElement;
        if (menu.getAttribute('trigger') !== 'hover' || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        menu.open = true;
      }, {capture: true, signal: this.events.signal});
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}
